export default __webpack_public_path__ + "static/media/phu.b4963a5b.jpg";